import { render, staticRenderFns } from "./MtrlAdd.vue?vue&type=template&id=55c312b6&scoped=true&"
import script from "./MtrlAdd.vue?vue&type=script&lang=js&"
export * from "./MtrlAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55c312b6",
  null
  
)

export default component.exports